import React from "react";
import styled from "@emotion/styled";
import { Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageIcon from "@mui/icons-material/Image";

const ShortNewsItemWrapper = styled(Link)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  text-decoration: none;
  width: 100%;
`;

const NewsType = styled(Typography)`
  text-transform: uppercase;
`;

const Image = styled.img`
  width: 106px;
  height: 72px;
  min-width: 106px;
  min-height: 72px;
  object-fit: contain;
  border-radius: 8px;
`;

const ImageStub = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 106px;
  height: 72px;
  min-width: 106px;
  min-height: 72px;
  background: ${({ theme }) => theme.palette.background.neutral};
  border-radius: 8px;
`;

const BrokenImage = styled(ImageIcon)`
  color: ${({ theme }) => theme.palette.icon.secondary};
`;

const TextBlockWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.palette.border.secondary}`};
`;

const NewsTitle = styled(Typography)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export interface NewsItem {
  title: string;
  link: string;
  imageURL?: string;
  showItemType?: boolean;
  openInNewPage?: boolean;
}

interface ShortNewsItemProps extends NewsItem {
  showBorder: boolean;
}

export const ShortNewsItem = (props: ShortNewsItemProps) => {
  const {
    link,
    title,
    imageURL,
    showItemType = true,
    openInNewPage = false,
  } = props;
  const { t } = useTranslation();

  return (
    <ShortNewsItemWrapper
      href={link}
      target={openInNewPage ? "_blank" : undefined}
      rel="noopener noreferrer"
    >
      {imageURL ? (
        <Image src={imageURL} />
      ) : (
        <ImageStub>
          <BrokenImage />
        </ImageStub>
      )}
      <TextBlockWrapper>
        {showItemType && (
          <NewsType variant="overline2" color="textSecondary">
            {t("dashboardPage.dashboard.newsBlock.item.type")}
          </NewsType>
        )}
        <NewsTitle variant="body2" color="textPrimary">
          {title}
        </NewsTitle>
      </TextBlockWrapper>
    </ShortNewsItemWrapper>
  );
};
